import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getAllSettingsApi } from "../Apis/settings/settings";

// جلب البيانات من MongoDB
export const fetchgetAllSettingsApi = createAsyncThunk(
  "getAllSettingsApi/fetchAll",
  async (_, { rejectWithValue }) => {
    try {
      console.log("🔄 SIMPLE: Fetching settings from MongoDB...");
      
      const response = await getAllSettingsApi();
      
      console.log("✅ SIMPLE: Settings fetched successfully:", {
        status: response.status,
        dataReceived: !!response.data,
        dataSize: response.data ? Object.keys(response.data).length : 0
      });
      
      return {
        data: response.data,
        status: response.status,
      };
    } catch (error) {
      console.error("❌ SIMPLE: Failed to fetch settings:", error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// الحالة الأولية البسيطة
const initialState = {
  data: null, // تغيير من [] إلى null للتمييز بين "لم يتم التحميل" و "فارغ"
  isLoading: false,
  status: null,
  error: null,
};

const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    // إعادة تعيين الأخطاء
    clearError: (state) => {
      state.error = null;
    },
    
    // إعادة تعيين البيانات
    resetSettings: (state) => {
      state.data = null;
      state.error = null;
      state.status = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchgetAllSettingsApi.pending, (state) => {
        console.log("⏳ SIMPLE: Loading settings...");
        state.isLoading = true;
        state.error = null;
        state.status = null;
      })
      .addCase(fetchgetAllSettingsApi.fulfilled, (state, action) => {
        console.log("✅ SIMPLE: Settings loaded successfully");
        state.isLoading = false;
        state.data = action.payload.data;
        state.status = action.payload.status;
      })
      .addCase(fetchgetAllSettingsApi.rejected, (state, action) => {
        console.error("❌ SIMPLE: Settings loading failed:", action.payload);
        state.isLoading = false;
        state.error = action.payload || "Something went wrong";
      });
  },
});

// تصدير الـ actions
export const { clearError, resetSettings } = settingsSlice.actions;

export default settingsSlice.reducer;